import styled from '@emotion/styled';
import Link from 'next/link';

const StyledLink = styled(Link)(
  {
    textDecoration: 'underline'
  },
  ({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.fontSize.medium,
    color: theme.palette.colors.black
  })
);

export default StyledLink;
